export enum SalePatternAutotext {
    CurrentMonthText,
    CurrentMonthNumber,
    CurrentMonthYear,
    PreviousMonthText,
    PreviousMonthNumber,
    PreviousMonthYear,
    NextMonthText,
    NextMonthNumber,
    NextMonthYear
}
